import {
  RectangleGroupIcon,
  Squares2X2Icon,
} from "@heroicons/react/24/outline";
import React, { useState } from "react";
import AreasManagement from "./AreasManagement";
import GroupsManagement from "./GroupsManagement";

interface ListsManagementProps {
  organizationId: string;
  orgRole: string;
  organization: any;
}

type TabType = "groups" | "areas";

const ListsManagement: React.FC<ListsManagementProps> = ({
  organizationId,
  orgRole,
  organization,
}) => {
  const [activeTab, setActiveTab] = useState<TabType>("groups");

  const canEdit = orgRole === "admin" || orgRole === "editor";
  const canDelete = orgRole === "admin";

  const tabs = [
    {
      id: "groups" as TabType,
      name: "Groups",
      icon: Squares2X2Icon,
      description: "Organize segments and propositions into groups",
    },
    {
      id: "areas" as TabType,
      name: "Functional Areas",
      icon: RectangleGroupIcon,
      description: "Manage business function areas for tasks and planning",
    },
  ];

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Lists & Selectors
        </h3>

        {/* Tab Navigation */}
        <div className="border-b border-gray-200 mb-6">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    py-2 px-1 border-b-2 font-medium text-sm flex items-center gap-2
                    ${
                      activeTab === tab.id
                        ? "border-blue-500 text-blue-600"
                        : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                    }
                  `}
                >
                  <Icon className="h-5 w-5" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        {activeTab === "groups" && (
          <div>
            <p className="text-sm text-gray-600 mb-4">
              Groups help organize your segments and propositions. You can
              create groups that apply to segments only, propositions only, or
              both.
            </p>
            <GroupsManagement
              organizationId={organizationId}
              canEdit={canEdit}
              canDelete={canDelete}
            />
          </div>
        )}

        {activeTab === "areas" && (
          <div>
            <p className="text-sm text-gray-600 mb-4">
              Functional areas represent different business functions in your
              organization. They are used in planning and task management to
              categorize work by department or function.
            </p>
            <AreasManagement
              organizationId={organizationId}
              orgRole={orgRole}
              _organization={organization}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default ListsManagement;
